import { useMemo } from 'react';

import { IDexPair } from 'types/pairs';
import { Modal } from 'ui/Modal/Modal';

import { TransfersSection } from './TransfersSection';

import { useMultiTransferTasks } from '../../api/useMultiTransferTasks';
import { getTransferTokenOptions } from '../../lib/tokens';

interface TransfersCenterProps {
  pair: IDexPair;
  onClose: () => void;
}

export const TransfersCenter = ({ pair, onClose }: TransfersCenterProps) => {
  const { data, isLoading, isFetching } = useMultiTransferTasks(pair.id, {
    refetchInterval: 6000,
  });

  const tokenMeta = useMemo(() => {
    const map = new Map<number, { symbol: string; decimals: number }>();
    getTransferTokenOptions(pair).forEach(option => {
      map.set(option.id, { symbol: option.symbol, decimals: option.decimals });
    });
    return map;
  }, [pair]);

  const tasks = data?.data?.items ?? [];
  const activeTasks = tasks.filter(task => !task.finished);
  const completedTasks = tasks.filter(task => task.finished);

  return (
    <Modal title="Transfers center" onClose={onClose} className="w-[720px]">
      <div className="flex flex-col gap-6">
        <TransfersSection
          title="In progress"
          tasks={activeTasks}
          tokenMeta={tokenMeta}
          network={pair.network}
          isLoading={isLoading || isFetching}
        />
        <TransfersSection
          title="Completed"
          tasks={completedTasks}
          tokenMeta={tokenMeta}
          network={pair.network}
        />
      </div>
    </Modal>
  );
};
